/**
 * Quick Actions Card Component
 *
 * Provides quick access to common donor actions
 */

import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  HeartIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  CreditCardIcon,
  Cog6ToothIcon,
  UserCircleIcon,
  HandRaisedIcon,
} from '@heroicons/react/24/outline';

export const QuickActionsCard: FC = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Donate Now',
      icon: HeartIcon,
      color: 'text-primary-600 bg-primary-50',
      enabled: true,
      onClick: () => navigate('/donate'),
    },
    {
      label: 'Make a Pledge',
      icon: HandRaisedIcon,
      color: 'text-emerald-600 bg-emerald-50',
      enabled: true,
      onClick: () => navigate('/pledge'),
    },
    {
      label: 'Manage Recurring',
      icon: ArrowPathIcon,
      color: 'text-green-600 bg-green-50',
      enabled: false,
      onClick: () => {}, // TODO: Navigate to recurring donations page
    },
    {
      label: 'Tax Receipts',
      icon: DocumentTextIcon,
      color: 'text-blue-600 bg-blue-50',
      enabled: false,
      onClick: () => {}, // TODO: Navigate to receipts page
    },
    {
      label: 'Payment Methods',
      icon: CreditCardIcon,
      color: 'text-purple-600 bg-purple-50',
      enabled: false,
      onClick: () => {}, // TODO: Navigate to payment methods page
    },
    {
      label: 'Profile Settings',
      icon: UserCircleIcon,
      color: 'text-orange-600 bg-orange-50',
      enabled: true,
      onClick: () => navigate('/profile'),
    },
    {
      label: 'Preferences',
      icon: Cog6ToothIcon,
      color: 'text-gray-600 bg-gray-50',
      enabled: false,
      onClick: () => {}, // TODO: Navigate to preferences page
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Quick Actions</h3>
        <p className="text-sm text-gray-600">Common tasks</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={action.onClick}
            className={`flex flex-col items-center justify-center p-4 rounded-lg border border-gray-200 hover:border-primary-300 hover:shadow-sm transition-all group ${!action.enabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={!action.enabled}
          >
            <div
              className={`p-3 rounded-full ${action.color} group-hover:scale-110 transition-transform`}
            >
              <action.icon className="h-6 w-6" />
            </div>
            <span className="mt-2 text-sm font-medium text-gray-900 text-center">
              {action.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
